import api from "./api";

const qs = (p = {}) =>
  new URLSearchParams(Object.entries(p).filter(([, v]) => v !== "" && v != null && v !== undefined)).toString();

export default {
  // Config
  buscarConfig:        (idCondominio) => api("GET",  `/controlid/config?idCondominio=${idCondominio}`),
  salvarConfig:        (data)         => api("POST", `/controlid/config`, data),
  testarConexao:       (idCondominio) => api("POST", `/controlid/config/testar`, { idCondominio }),
  regenerarSecret:     (idCondominio) => api("POST", `/controlid/config/regenerar-secret`, { idCondominio }),

  // Dispositivos
  listarDispositivos:  (idCondominio) => api("GET",  `/controlid/dispositivos?idCondominio=${idCondominio}`),
  criarDispositivo:    (data)         => api("POST", `/controlid/dispositivos`, data),
  editarDispositivo:   (id, data)     => api("PUT",  `/controlid/dispositivos/${id}`, data),
  excluirDispositivo:  (id)           => api("DELETE",`/controlid/dispositivos/${id}`),
  sincDisp:            (idCondominio) => api("POST", `/controlid/dispositivos/sincronizar`, { idCondominio }),

  // Pessoas
  listarPessoas:       (params = {})  => api("GET",  `/controlid/pessoas?${qs(params)}`),
  criarPessoa:         (data)         => api("POST", `/controlid/pessoas`, data),
  editarPessoa:        (id, data)     => api("PUT",  `/controlid/pessoas/${id}`, data),
  excluirPessoa:       (id)           => api("DELETE",`/controlid/pessoas/${id}`),
  importarMoradores:   (idCondominio) => api("POST", `/controlid/pessoas/importar-moradores`, { idCondominio }),
  sincPessoa:          (id, idCondominio) => api("POST", `/controlid/pessoas/${id}/sincronizar`, { idCondominio }),
  sincTodos:           (idCondominio) => api("POST", `/controlid/pessoas/sincronizar-todos`, { idCondominio }),

  // Logs
  listarLogs:          (params = {})  => api("GET",  `/controlid/logs?${qs(params)}`),
};
